import { CREAR_MOVIMIENTO_CUENTA_CORRIENTE, EXCEL_CUENTA_CORRIENTE, VENTA_CUENTA_CORRIENTE } from "../constants";
import Axios from "../extras/Axios";

export async function obtenerDatosParaCuentaCorriente(identificador, dateTo, dateFrom) {
  const { data, status } = await Axios.get(VENTA_CUENTA_CORRIENTE, { params: { dateFrom, dateTo, identificador } });
  if (status !== 200) return null;
  return data;
}

export async function obtenerExcelCuentaCorriente() {
  const { data } = await Axios.get(EXCEL_CUENTA_CORRIENTE);
 
  return data;
}

export async function crearNuevoMovimiento(movimiento) {
  const resultado = await Axios.post(CREAR_MOVIMIENTO_CUENTA_CORRIENTE, movimiento);
  if (resultado.status !== 201) return false;
  return true;
}